export default "__VITE_ASSET__CYehv8ey__"